import React from 'react';
import { parseISO, format } from 'date-fns';
import { Link } from 'react-router-dom';

import { STAT } from 'config/url';

const ResultPreview = ({id, name, score, max_score, started_at, ended_at}) => {
  const dateStart = parseISO(started_at);
  const dateEnd = ended_at ? parseISO(ended_at) : undefined;
  return (
    <div className="column is-one-quarter">
      <Link to={STAT(id)}>
      <div className="card result-preview">
        <div className="p-3 m-0 has-background-primary-light">
          <h5 className="title is-5">{name}</h5>
        </div>
        <div className="card-content p-3">
          <p>
            {score}/{max_score}
          </p>
          <p>
            Commencé le {format(dateStart, "dd/MM/yyyy HH'h'mm")}
          </p>
          <p>
            {dateEnd &&
            `Fini le ${format(dateEnd, "dd/MM/yyyy HH'h'mm")}`
            }
          </p>
        </div>
      </div>
      </Link>
    </div>
  )
}

const Results = ({series}) => {
  return (
    <div className="columns is-multiline">
      {series.map((serie) =>
        <ResultPreview {...serie} />
      )}
    </div>
  )
}

export default Results;